import { render, staticRenderFns } from "./formwizard.vue?vue&type=template&id=c96d754c"
import script from "./formwizard.vue?vue&type=script&lang=js"
export * from "./formwizard.vue?vue&type=script&lang=js"
import style0 from "vue-form-wizard/dist/vue-form-wizard.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./formwizard.vue?vue&type=style&index=1&id=c96d754c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports